export const checkPath = "<path d=\"M3.5 8.5 L7 12 L12.5 4\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>"
